import { css } from "lit";

export const statusBadgeStyles = css`
  .badge {
    --badge-letter-spacing: 1px;
    font-weight: 700;
  }

  .badge.live {
    --badge-bg: rgb(34 197 94 / 0.2);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.ended {
    --badge-bg: var(--sds-color-background-default-tertiary);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.cancelled {
    --badge-bg: var(--sds-color-background-default-secondary);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.scheduled {
    --badge-bg: var(--sds-color-background-default-secondary);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.price {
    --badge-bg: var(--sds-color-background-default-secondary);
    --badge-color: var(--sds-color-text-default-secondary);
  }

  .badge.access {
    --badge-bg: var(--sds-color-background-success-default);
    --badge-color: var(--sds-color-text-success-on-success);
  }

  .badge.pulse {
    animation: badge-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  @keyframes badge-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }
`;
